import { DomainModelSerialCollection } from './domain-model-serial-collection';
import { BaseRowNumberModel } from './base-row-number-model';
import type { IdentityInterface } from '@nts/std/interfaces';


export abstract class DomainModelSerialRowNumberCollection<TItem extends BaseRowNumberModel<TIdentity>, TIdentity extends IdentityInterface>
    extends DomainModelSerialCollection<TItem, TIdentity> {

}
